import React, { lazy, useEffect, useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import { FaAngleLeft } from "react-icons/fa";
import flag_2 from "../assets/img/tarh-parcham-iran-psdtarh2.png";
import MainLayout from "../layout/main";
import { ApiEndpoints, useApiCall } from "../api";
import Loading from "../component/loading";
import { useTableDataGenerator } from "../helper/common";
import { appRoutes, useAppNavigation } from "../router/routes";
import { Table } from "../component/table";
import { SelectOption } from "../component/selectOption";
import { LIST_PAGE_SIZE } from "../config";
import { IoClose } from "react-icons/io5";
import { storageApi } from "../storage/storageApi";
import { useAlert } from "react-alert";
import { Input } from "../component/input";
import { confirmAlert } from "react-confirm-alert";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import moment from "moment-jalali";
import { useValidation, ValidationTypes } from "../helper/validation";
import { jalaliMonth, toDateString } from "../helper/dateHelper";

const MonasebatList = () => {
  const { navigate, queryParameter } = useAppNavigation();
  const [monasebatId, setMonasebatId] = useState(0);
  const [selectedEvent, setSelectedEvent] = useState(false);
  const [cPage, setCPage] = useState(queryParameter().get("page"));
  const userProfile = storageApi.useGetUser();
  const [selectedMonth, setSelectedMonth] = useState("");
  const [is_active, setIs_active] = useState(false);
  const [updateIs_active, setUpdateIs_active] = useState(false);
  const [updateDateLimit, setUpdateDateLimit] = useState(false);
  const [implementationDate, setImplementationDate] = useState("");
  const [selectedDay, setSelectedDay] = useState(null);
  const [title, setTitle] = useState("");
  const [mehvarFaaliat, setMehvarFaaliat] = useState("");
  const [updateMonasebat, setUpdateMonasebat] = useState("");
  const [id, setId] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [reportDescription, setReportDescription] = useState("");
  const [showModalUpdate, setShowModalUpdate] = useState(false);
  const alert = useAlert();
  const { errors, validate, removeError } = useValidation([
    {
      name: "implementationDate",
      label: "تاریخ اجرا",
      value: implementationDate,
      validations: [
        {
          type: ValidationTypes.stringRequired,
        },
      ],
    },
  ]);

  useEffect(() => {
    handleGetMonasebat();
  }, []);
  const handleGetMonasebat = () => {
    monasebatList = handleFetchMonasebat();
  };
  useEffect(() => {
    if (cPage > 0) {
      handleGetMonasebat();
    }
  }, [cPage]);
  let [[monasebatList], { fetch: handleFetchMonasebat, loading }] = useApiCall({
    endpoints: [ApiEndpoints.monasebatListByAdmin.List],
    payload: {
      page: cPage,
    },
  });

  const [[profile]] = useApiCall({
    endpoints: [ApiEndpoints.user.profile],
  });
  const { data, setPage, currentPage, totalPageCount } = useTableDataGenerator(
    monasebatList?.data.results ?? [],
    {
      filters: {},
    },
    monasebatList?.data.count,
  );
  const [[eventList], { loading: eventLoading }] = useApiCall({
    endpoints: ApiEndpoints.events.list,
  });
  useEffect(() => {
    if (!eventLoading) {
      const eventId = queryParameter().get("eventId")?.toString();
      const event = eventList?.data?.find((c) => c.id.toString() === eventId);
      setSelectedEvent(event);
      event &&
        setSelectedDay({
          year: parseInt(moment(event.date).format("jYYYY")),
          month: parseInt(moment(event.date).add("d").format("jM")),
          day: parseInt(moment(event.date).add("d").format("jD")),
        });
    }
  }, [eventLoading]);
  const [, { loading: deleteLoading, fetch: handleDeleteMonasebat }] =
    useApiCall({
      endpoints: ApiEndpoints.monasebatListByAdmin.delete,
      payload: { id },
      lazy: true,
    });
  const [, { loading: postLoading, fetch: handleAddMonasebat }] = useApiCall({
    endpoints: ApiEndpoints.monasebatListByAdmin.addMonasebat,
    payload: {
      title,
      mehvarFaaliat,
      implementationDate,
      selectedMonth,
      reportDescription,
      updateDateLimit,
      is_active,
    },
    lazy: true,
  });
  const [, { loading: handleUpdateLoading, fetch: handleUpdateMonasebat }] =
    useApiCall({
      endpoints: [ApiEndpoints.monasebatListByAdmin.updateMonasebat],
      payload: {
        updateMonasebat,
        mehvarFaaliat,
        implementationDate,
        selectedMonth,
        reportDescription,
        updateDateLimit,
        updateIs_active,
        id,
      },
      lazy: true,
    });

  const onClickDelete = (i) => {
    console.log(i.id);
    confirmAlert({
      title: "",
      message: "آیا از حذف مناسبت مطمئن هستید ؟",
      buttons: [
        {
          label: (
            <div>
              بله
              <Loading isLoading={loading} />
            </div>
          ),
          onClick: async () => {
            const [{ isOk }] = await handleDeleteMonasebat({
              id: i.id,
            });
            if (isOk) {
              window.location.reload();
            }
          },
        },
        {
          label: "خیر",
          onClick: () => {},
        },
      ],
    });
  };
  console.log(monasebatId);

  const setTablePage = (pageNumber) => {
    setCPage(pageNumber + 1);
  };
  const onChangeModalAdd = () => {
    setShowModal(true);
  };
  const onChangeModal = (i) => {
    setShowModalUpdate(true);
    setUpdateMonasebat(i.title);
    setMehvarFaaliat(i.mehvar_faaliat);
    setSelectedMonth(i.month);
    setUpdateIs_active(i.is_active);
    setUpdateDateLimit(i.date_limit_in_use_once_a_year);
    setId(i.id);
  };
  const hideModal = () => {
    setShowModal(false);
  };
  const hideModalUpdate = () => {
    setShowModalUpdate(false);
  };
  const submitForm = async () => {
    const [updateResult] = await handleAddMonasebat();
    if (updateResult.isOk) {
      alert.success("افزوده شد");
      handleGetMonasebat();
      hideModal();
    }
  };
  console.log(implementationDate);
  const submitFormUpdate = async () => {
    const [updateResult] = await handleUpdateMonasebat();
    if (updateResult.isOk) {
      alert.success("بروزرسانی موفق");
      handleGetMonasebat();
      hideModalUpdate();
    }
  };
  const handleCheckboxChange = () => {
    setIs_active(!is_active);
  };
  const handleDateCheckboxChange = () => {
    setUpdateDateLimit(!updateDateLimit);
  };
  const handleUpdateCheckboxChange = () => {
    setUpdateIs_active(!updateIs_active);
  };
  const handleUpdateDateCheckboxChange = () => {
    setUpdateDateLimit(!updateDateLimit);
  };
  return (
    <MainLayout>
      <div className="content-style flex flex-col gap-8 md:p-8 p-4 bg-gray-100 h-full  shadow-sm w-full">
        {/* sec1 */}
        <div className="sec1 w-full bg-greenblue-light h-auto md:rounded-3xl rounded-xl relative p-8 md:min-h-[180px] min-h-[100px]">
          <img src={flag_2} className=" absolute left-0 top-0 md:h-42 h-24" />
          <div className="flex flex-col gap-8 justify-center items-center w-[60%] h-full mx-auto">
            <div className="md:text-3xl text-xl text-center font-bold">
              <span className=" text-greenblue"> مدیریت مناسبت ها </span>
            </div>
            {/* form search list */}
          </div>
        </div>
        <button
          onClick={() => onChangeModalAdd()}
          className="flex gap-1 bg-green-200 text-green-700 px-3 py-2 rounded-xl w-32 self-end"
        >
          افزودن
          <span className="mr-9">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="size-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
          </span>
        </button>
        <Table
          loading={loading}
          data={data}
          hasPagination
          totalPageCount={totalPageCount}
          totalCount={monasebatList?.data.count}
          setPage={setTablePage}
          currentPage={currentPage}
          header={[
            {
              name: "ردیف",
              width: 1,
              render: (i) =>
                cPage == null
                  ? i.rowIndex
                  : i.rowIndex + (cPage - 1) * LIST_PAGE_SIZE,
            },
            {
              name: "عنوان مناسبت",
              width: 2,
              render: (i) => i.title,
            },
            {
              name: "محور فعالیت",
              width: 2,
              render: (i) => i.mehvar_faaliat,
            },
            {
              name: "ماه",
              width: 1,
              render: (i) => i.month,
            },
            {
              name: "تاریخ مناسبت",
              width: 1,
              render: (i) =>
                i.created === "-" ? "-" : toDateString(i.date, "jYYYY/jMM/jDD"),
            },
            {
              name: "وضعیت",
              width: 1,
              render: (i) => (i.is_active ? "فعال" : "غیر فعال"),
            },
            {
              name: "تاریخ ایجاد",
              width: 1,
              render: (i) =>
                i.created === "-"
                  ? "-"
                  : toDateString(i.created, "jYYYY/jMM/jDD"),
            },
            {
              name: "اخرین تغییرات",
              width: 1,
              render: (i) =>
                i.last_modified === "-"
                  ? "-"
                  : toDateString(i.last_modified, "jYYYY/jMM/jDD"),
            },
            {
              name: "عملیات",
              width: 2,
              render: (i) => (
                <div className="flex gap-8">
                  {userProfile.role === "admin" && (
                    <button
                      onClick={() => onChangeModal(i)}
                      className="flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl"
                    >
                      ویرایش
                    </button>
                  )}
                  <button
                    onClick={() => onClickDelete(i)}
                    className="flex items-center gap-1 bg-red-100 text-red-500 px-3 py-2 rounded-xl"
                  >
                    حذف
                  </button>
                </div>
              ),
            },
          ]}
        />
      </div>
      {showModal && (
        <div
          className={`z-[10000] bg-gray-900 bg-opacity-40 w-screen h-screen  fixed top-0 left-0 overflow-y-scroll edit-modal`}
        >
          <div
            className="md:w-[768px] w-[350px] md:max-h-[900px] md:min-h-[400px]  rounded-xl p-8 bg-white absolute
           top-[50%] -translate-y-[50%] left-[50%] -translate-x-[50%] flex align-center flex-col"
          >
            <div className=" text-center text-lg font-semibold mb-4 ">
              <div
                className=" absolute left-6 top-6 z-40 p-2 text-gray-500"
                onClick={hideModal}
              >
                <IoClose size={24} className="cursor-pointer" />
              </div>
              افزودن مناسبت{" "}
            </div>
            <div className="flex f justify-center flex-col mt-10 w-full self-center">
              {userProfile.role === "admin" && (
                <>
                  <div className="w-full">
                    <div className="form-field w-full relative mt-2">
                      <Input
                        type="text"
                        placeholder="وارد کنید"
                        label="عنوان مناسبت:"
                        value={title}
                        onChange={(e) => {
                          setTitle(e);
                        }}
                      />
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <Input
                        type="text"
                        placeholder="وارد کنید"
                        label="محور فعالیت:"
                        value={mehvarFaaliat}
                        onChange={(e) => {
                          setMehvarFaaliat(e);
                        }}
                      />
                    </div>
                    <div className="flex f justify-center items-center form-field w-full relative mt-2">
                      <select
                        type="text"
                        placeholder="شماره یک"
                        className=" rounded-lg w-50% p-2 pr-8 border-[1.5px] border-gray-100 text-sm"
                        onChange={(e) => setSelectedMonth(e.target.value)}
                      >
                        <option name="month" value="">
                          انتخاب ماه
                        </option>
                        {jalaliMonth.map((c) => (
                          <option name={"month"} value={c}>
                            {c}
                          </option>
                        ))}
                      </select>
                      <span className=" px-3 text-[12px] right-2">
                        {" "}
                        زمان اجرا{" "}
                      </span>
                      <div
                        className={`rounded-lg p-4 border-[1px] bg-white border-gray-100 w-50% text-sm pl-8 ${errors["implementationDate"] ? "date-picker-input-error" : ""}`}
                      >
                        <DatePicker
                          inputClassName={`date-picker-input cursor-pointer ${implementationDate ? "" : "opacity-0"}`}
                          className="text-white"
                          calendarSelectedDayClassName="text-red"
                          locale={"fa"}
                          value={selectedDay}
                          onChange={(date) => {
                            setSelectedDay(date);
                            const { day, month, year } = date;
                            setImplementationDate(
                              moment(
                                `${year}/${month}/${day}`,
                                "jYYYY/jM/jD",
                              ).format("YYYY-MM-DD"),
                            );
                            removeError("implementationDate");
                          }}
                          inputPlaceholder={"انتخاب زمان اجرا"}
                          minimumDate={
                            selectedEvent &&
                            (selectedEvent.date_limit_in_use_once_a_year
                              ? {
                                  year: parseInt(
                                    moment(selectedEvent?.date)
                                      .add("d", -5)
                                      .format("jYYYY"),
                                  ),
                                  month: parseInt(
                                    moment(selectedEvent?.date)
                                      .add("d", -5)
                                      .format("jM"),
                                  ),
                                  day: parseInt(
                                    moment(selectedEvent?.date)
                                      .add("d", -5)
                                      .format("jD"),
                                  ),
                                }
                              : {
                                  year: parseInt(
                                    moment(selectedEvent?.date)
                                      .add("d", -5)
                                      .format("jYYYY"),
                                  ),
                                  month: parseInt(1),
                                  day: parseInt(1),
                                })
                          }
                          maximumDate={
                            selectedEvent &&
                            (selectedEvent.date_limit_in_use_once_a_year
                              ? {
                                  year: parseInt(
                                    moment(selectedEvent?.date)
                                      .add("d", 5)
                                      .format("jYYYY"),
                                  ),
                                  month: parseInt(
                                    moment(selectedEvent?.date)
                                      .add("d", 5)
                                      .format("jM"),
                                  ),
                                  day: parseInt(
                                    moment(selectedEvent?.date)
                                      .add("d", 5)
                                      .format("jD"),
                                  ),
                                }
                              : {
                                  year: parseInt(
                                    moment(selectedEvent?.date)
                                      .add("d", 5)
                                      .format("jYYYY"),
                                  ),
                                  month: parseInt(12),
                                  day: parseInt(30),
                                })
                          }
                        />
                      </div>
                      {errors["implementationDate"] && (
                        <p className={"text-sm mt-2 text-red-600"}>
                          {errors["implementationDate"]}
                        </p>
                      )}
                    </div>
                    <div className="form-field w-full relative">
                      <span className="px-3 text-[12px] right-2">
                        جزئیات اجرای مناسبت:
                      </span>
                      <textarea
                        type="text"
                        placeholder="جزئیات اجرای مناسبت"
                        className=" rounded-lg p-4 border-[1.5px] border-gray-100 w-full text-sm pl-8"
                        rows="5"
                        maxLength={1400}
                        value={reportDescription}
                        onChange={(e) => {
                          setReportDescription(e.target.value);
                        }}
                      ></textarea>
                      <span className="px-3 text-[12px] right-2">
                        تعداد کاراکتر: {reportDescription?.length ?? 0}
                        حداقل کاراکتر مورد قبول : ۱۰۰ کاراکتر
                      </span>
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <div>
                        <label className="rounded-xl">
                          <input
                            type="checkbox"
                            checked={is_active}
                            onChange={handleCheckboxChange}
                          />
                          فعال
                        </label>
                      </div>
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <div>
                        <label className="rounded-xl">
                          <input
                            type="checkbox"
                            checked={updateDateLimit}
                            onChange={handleDateCheckboxChange}
                          />
                          محدود کردن به افزودن تعداد محدودی برنامه در بازه محدود
                          به تاریخ اجرا
                        </label>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="flex justify-center mt-10">
              <button
                onClick={submitForm}
                className="w-5/12 bg-green-600 text-white px-3 py-2 rounded-xl"
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      )}
      {showModalUpdate && (
        <div
          className={`z-[10000] bg-gray-900 bg-opacity-40 w-screen h-screen  fixed top-0 left-0 overflow-y-scroll edit-modal`}
        >
          <div
            className="md:w-[768px] w-[350px] md:max-h-[900px] md:min-h-[400px]  rounded-xl p-8 bg-white absolute
           top-[50%] -translate-y-[50%] left-[50%] -translate-x-[50%] flex align-center flex-col"
          >
            <div className=" text-center text-lg font-semibold mb-4 ">
              <div
                className=" absolute left-6 top-6 z-40 p-2 text-gray-500"
                onClick={hideModalUpdate}
              >
                <IoClose size={24} className="cursor-pointer" />
              </div>
              ویرایش مناسبت{" "}
            </div>
            <div className="flex f justify-center flex-col mt-10 w-full self-center">
              {userProfile.role === "admin" && (
                <>
                  <div className="w-full">
                    <div className="form-field w-full relative mt-2">
                      <Input
                        type="text"
                        placeholder="وارد کنید"
                        label="عنوان مناسبت:"
                        value={updateMonasebat}
                        onChange={(e) => {
                          setUpdateMonasebat(e);
                        }}
                      />
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <Input
                        type="text"
                        placeholder="وارد کنید"
                        label="محور فعالیت:"
                        value={mehvarFaaliat}
                        onChange={(e) => {
                          setMehvarFaaliat(e);
                        }}
                      />
                    </div>
                    <div className="flex f justify-center items-center form-field w-full relative mt-2">
                      <select
                        type="text"
                        placeholder="شماره یک"
                        className=" rounded-lg w-50% p-2 pr-8 border-[1.5px] border-gray-100 text-sm"
                        onChange={(e) => setSelectedMonth(e.target.value)}
                      >
                        <option name="month" value="">
                          {selectedMonth}{" "}
                        </option>
                        {jalaliMonth.map((c) => (
                          <option name={"month"} value={c}>
                            {c}
                          </option>
                        ))}
                      </select>
                      <span className=" px-3 text-[12px] right-2">
                        {" "}
                        زمان اجرا{" "}
                      </span>
                      <div
                        className={`rounded-lg p-4 border-[1px] bg-white border-gray-100 w-50% text-sm pl-8 ${errors["implementationDate"] ? "date-picker-input-error" : ""}`}
                      >
                        <DatePicker
                          inputClassName={`date-picker-input cursor-pointer ${implementationDate ? "" : "opacity-0"}`}
                          className="text-white"
                          calendarSelectedDayClassName="text-red"
                          locale={"fa"}
                          value={selectedDay}
                          onChange={(date) => {
                            setSelectedDay(date);
                            const { day, month, year } = date;
                            setImplementationDate(
                              moment(
                                `${year}/${month}/${day}`,
                                "jYYYY/jM/jD",
                              ).format("YYYY-MM-DD"),
                            );
                            removeError("implementationDate");
                          }}
                          inputPlaceholder={"انتخاب زمان اجرا"}
                          minimumDate={
                            selectedEvent &&
                            (selectedEvent.date_limit_in_use_once_a_year
                              ? {
                                  year: parseInt(
                                    moment(selectedEvent?.date)
                                      .add("d", -5)
                                      .format("jYYYY"),
                                  ),
                                  month: parseInt(
                                    moment(selectedEvent?.date)
                                      .add("d", -5)
                                      .format("jM"),
                                  ),
                                  day: parseInt(
                                    moment(selectedEvent?.date)
                                      .add("d", -5)
                                      .format("jD"),
                                  ),
                                }
                              : {
                                  year: parseInt(
                                    moment(selectedEvent?.date)
                                      .add("d", -5)
                                      .format("jYYYY"),
                                  ),
                                  month: parseInt(1),
                                  day: parseInt(1),
                                })
                          }
                          maximumDate={
                            selectedEvent &&
                            (selectedEvent.date_limit_in_use_once_a_year
                              ? {
                                  year: parseInt(
                                    moment(selectedEvent?.date)
                                      .add("d", 5)
                                      .format("jYYYY"),
                                  ),
                                  month: parseInt(
                                    moment(selectedEvent?.date)
                                      .add("d", 5)
                                      .format("jM"),
                                  ),
                                  day: parseInt(
                                    moment(selectedEvent?.date)
                                      .add("d", 5)
                                      .format("jD"),
                                  ),
                                }
                              : {
                                  year: parseInt(
                                    moment(selectedEvent?.date)
                                      .add("d", 5)
                                      .format("jYYYY"),
                                  ),
                                  month: parseInt(12),
                                  day: parseInt(30),
                                })
                          }
                        />
                      </div>
                      {errors["implementationDate"] && (
                        <p className={"text-sm mt-2 text-red-600"}>
                          {errors["implementationDate"]}
                        </p>
                      )}
                    </div>
                    <div className="form-field w-full relative">
                      <span className="px-3 text-[12px] right-2">
                        جزئیات اجرای مناسبت:
                      </span>
                      <textarea
                        type="text"
                        placeholder="جزئیات اجرای مناسبت"
                        className=" rounded-lg p-4 border-[1.5px] border-gray-100 w-full text-sm pl-8"
                        rows="5"
                        value={reportDescription}
                        onChange={(e) => {
                          setReportDescription(e.target.value);
                        }}
                      ></textarea>
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <div>
                        <label className="rounded-xl">
                          <input
                            type="checkbox"
                            checked={updateIs_active}
                            onChange={handleUpdateCheckboxChange}
                          />
                          فعال
                        </label>
                      </div>
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <div>
                        <label className="rounded-xl">
                          <input
                            type="checkbox"
                            checked={updateDateLimit}
                            onChange={handleUpdateDateCheckboxChange}
                          />
                          محدود کردن به افزودن تعداد محدودی برنامه در بازه محدود
                          به تاریخ اجرا
                        </label>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="flex justify-center mt-10">
              <button
                onClick={submitFormUpdate}
                className="w-5/12 bg-green-600 text-white px-3 py-2 rounded-xl"
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default MonasebatList;
